export const productionConfig = {
  apiKey: 'AIzaSyAJUKq5dBzdfAPtLem4RVBWCFTGOK_qdO4',
  authDomain: 'relyht-dbe3c.firebaseapp.com',
  databaseURL: 'https://relyht-dbe3c.firebaseio.com',
  projectId: 'relyht-dbe3c',
  storageBucket: 'relyht-dbe3c.appspot.com',
  messagingSenderId: '406090230664',
  appId: '1:406090230664:web:4148e71068cba04fbca83d',
  measurementId: 'G-VKJSQ6R938',
};
